import React from 'react';
import PropTypes from 'prop-types';

import styles from './Discount.scss';

const Discount = ({discount,smallFont}) => {
	return (
		<div className={`${styles.discount} ${smallFont === true && styles.smallFont}`}>
			<span className={styles.amount}>-{discount}</span>
			<span className={styles.sign}>%</span>
		</div>
	);
};
Discount.defaultProps = {};

//
Discount.propTypes = {
	discount: PropTypes.number.isRequired,
	smallFont: PropTypes.bool,
};

export default Discount;